import { useState } from "react"

import { useTranslation } from "react-i18next"

import Icon from "../../../../../Icon"
import AppUtils from "../../../../../Utils/utils"
import {
  GROUP_META,
  MATCH_TYPE_LABEL,
  STATUS_META,
  STATUS_PERCENTAGE
} from "../../constants/constants"
import DescriptorHeaderAddon from "../DescriptorHeaderAddon/DescriptorHeaderAddon"

import styles from "./descriptor-row.module.less"

// `hideLogs` drops the Status logs trigger entirely — used when the same row
// component renders as the header inside the Status Logs popup (BLOCK 4.2 of
// CHA1-1967) where the trigger would be redundant.
const DescriptorRow = ({
  row,
  onLogsClick,
  hideLogs,
  usersViewForAdmin,
  onStatusChange,
  onMatchTypeChange
}) => {
  const { t } = useTranslation()
  const meta = STATUS_META[row.current_status] || {}
  const groupClass = (GROUP_META[row.status_group] || GROUP_META.unenrolled).class
  const percent = STATUS_PERCENTAGE[row.current_status] ?? 100

  const [isCopied, setIsCopied] = useState(false)

  const copyName = () => {
    AppUtils.copyToClipboard(row.billing_descriptor)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1500)
  }

  return (
    <div className={styles.row}>
      <div className={styles.rowTop}>
        <div className={styles.rowLeft}>
          <button type="button" className={styles.copyBtn} onClick={copyName}>
            {isCopied ? <Icon type="check" /> : <Icon type="copy" />}
          </button>
          <span className={styles.descriptorName}>{row.billing_descriptor}</span>
          {/* Support edits match type and status in place (CHA1-1975 BLOCK 3);
              the merchant reads the same two values as plain text. */}
          {usersViewForAdmin ? (
            <DescriptorHeaderAddon
              row={row}
              onStatusChange={onStatusChange}
              onMatchTypeChange={onMatchTypeChange}
            />
          ) : (
            <>
              {row.match_type ? (
                <>
                  <span className={styles.matchType}>{t(MATCH_TYPE_LABEL[row.match_type])}</span>
                  <span className={styles.divVertical} />
                </>
              ) : null}
              <span className={`${styles.rowStatusText} ${styles[groupClass]}`}>
                {t(meta.label || row.current_status)}
              </span>
            </>
          )}
        </div>
        {!hideLogs ? (
          <button
            type="button"
            className={styles.statusLogsButton}
            onClick={onLogsClick}
            data-testid={`deflect-business-status-logs-btn-${row.record_id}`}
          >
            <Icon type="info_bubble" className={styles.statusLogsButtonIcon} />

            {t("Status logs")}
          </button>
        ) : null}
      </div>

      <div className={styles.scale}>
        <div
          className={`${styles.scaleFilled} ${styles[groupClass]}`}
          style={{ width: `${percent}%` }}
        />
      </div>

      <p className={styles.explanation}>{t(meta.explanation || "")}</p>
    </div>
  )
}

export default DescriptorRow
